<template>
  <div
    :class="[
      'search-content',
      {'open-aside': openAside},
      {'open-detail': detail}
    ]"
    v-loading="loading.full">

    <Navbar v-if="viewconfig && viewconfig.nav"/>

    <main
      ref="main"
      v-if="viewconfig && viewconfig.main"
      v-loading="loading.main"
      :class="[
        {'detailExpand': detailExpand},
        {'sm': main.width < 660}
      ]">

      <!-- Titulo -->
      <section class="main-header" v-if="viewconfig && viewconfig.main_header">

        <h1 v-if="viewconfig && viewconfig.main_header_title">
          <i class="el-icon-menu" v-if="viewconfig.aside" @click="openAside = true"></i>
          {{titlePortal}}
        </h1>

        <!-- Tipo de vista -->
        <HeaderViewType 
        v-if="viewconfig && viewconfig.main_header_viewtype && !viewconfig.main_filters_grouped"
        :viewTypeSearch="viewTypeSearch"
        @change="(val) => viewTypeSearch = val"/>

      </section>

      <!-- Filtros -->
      <section class="filters" v-if="viewconfig && viewconfig.main_filters">

        <div v-click-outside="outsideFilters" :class="['filters-content', {'filters-content-grouped': viewconfig.main_filters_grouped}, {'show-grouped-filters': showGroupedFilters}, {'filters-esquema': (queryparams.filter == 'esquema' && esquema_selected)}]">

          <!-- FILTRO - Colecciones / esquemas -->
          <el-button
            size="small"
            icon="el-icon-notebook-2"
            @click="dialogColection.open = true">
            {{ getColeccionFilterName }}
          </el-button>

          <!-- FILTRO - comunes -->
          <div class="filters-comun">

            <!-- por defecto descripcion y contiene -->
            <el-select
              v-model="filtro_comun.select"
              class="select-filter"
              size="small">
              <el-option
                v-for="(filter,i) in getFilterSearch.filter(f => !['tipo_documento__id','fechas_documento','colecciones'].includes(f.key))"
                :key="i"
                :label="filter.placeholder"
                :value="filter.key">
              </el-option>
            </el-select>

            <el-select
              v-model="filtro_comun.comparador"
              class="select-comparador"
              size="small">

              <el-option
                style="min-width: 180px;"
                v-for="(operator, i) in filters_operator"
                :key="i"
                :label="operator.operator"
                :value="operator.id">
                  <span style="float: left">{{ operator.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ operator.operator}}</span>
              </el-option>
            </el-select>

            <el-input
              size="small"
              v-model="filtro_comun.value"
              class="input-buscador"
              type="text"
              suffix-icon="el-icon-search"
              @keyup.enter.native="saveFilter($event, filtro_comun, 'filters_tags'); goSearch()"/>
          </div>

          <!-- FILTRO - fechas -->
          <div class="filters-date">

            <el-select
              v-model="filtro_fecha.select"
              size="small"
              class="select-dates">

              <el-option
              style="min-width: 180px;"
              v-for="(date, i) in filters_date"
              :key="i"
              :label="date.placeholder"
              :value="date.key" />
            </el-select>

            <el-date-picker
              size="small"
              v-model="filtro_fecha.date"
              :picker-options="{firstDayOfWeek: 1}"
              type="daterange"
              align="right"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              start-placeholder="Desde"
              end-placeholder="Hasta"
              @change="saveFilterFecha(); goSearch()">
            </el-date-picker>
          </div>

          <!-- Desplegable de filtros agrupados -->
          <div class="more-filters-button" @click="showGroupedFilters = !showGroupedFilters">
            <i class="el-icon-caret-bottom"></i>
          </div>

          <!-- Filtros agrupados -->
          <div class="grouped-filters" v-show="showGroupedFilters">
            
              <el-button
                class="filter-collection"
                size="small"
                icon="el-icon-notebook-2"
                @click="dialogColection.open = true">
                {{ getColeccionFilterName }}
              </el-button>

              <!-- Metadatos -->
              <div class="filter-input" v-if="documentTypeSelect && propertiesByDocumentType.length">
                <span>Metadatos</span>
                <div class="filter-input-content">
                  <div class="filter-metadatos">

                    <!-- Listar tipos de propiedades -->
                    <div @click.prevent.stop="dialogFilterProperty.open = true">
                      <el-input
                        :disabled="loading.main"
                        size="small"
                        type="text"
                        placeholder="Selecciona una propiedad"
                        :value="document_filters_property ? propertiesByDocumentType.find(f => f.id == document_filters_property).descripcion.replace(/_|#|-|@|<>/g, ' ') : ''"
                        :readonly="true" />
                    </div>
                    
                    <el-input
                    :disabled="loading.main"
                    v-model="document_filters_property_input.value"
                    @keyup.enter.native="saveFilter($event,{}, 'document_filters_tags'); goSearch()"
                    type="text"
                    placeholder="Introduce valor"
                    class="input-with-select"
                    size="small">
                      <el-select v-model="document_filters_property_input.comparador" slot="prepend" placeholder="Select">
                        <el-option
                        style="min-width: 180px;"
                        v-for="(operator, i) in filters_operator"
                        :key="i"
                        :label="operator.operator"
                        :value="operator.id">
                          <span style="float: left">{{ operator.label }}</span>
                          <span style="float: right; color: #8492a6; font-size: 13px">{{ operator.operator}}</span>
                        </el-option>
                      </el-select>
                    </el-input>
                      
                    <el-button
                    :disabled="loading.main"
                    type="default"
                    icon="el-icon-plus"
                    size="small"
                    @click="saveFilter($event,{}, 'document_filters_tags'); goSearch()">Filtro</el-button>
                  </div>

                  <div v-if="document_filters_tags && document_filters_tags.length">
                    <el-tag
                      size="mini"
                      type="info"
                      v-if="loading.main">
                      Limpiar filtros
                    </el-tag>
                    <el-tag
                      v-else
                      @click="removeFilters('document_filters_tags'); goSearch()"
                      size="mini"
                      type="danger"
                      style="cursor: pointer">
                      Limpiar filtros
                    </el-tag>

                    <el-tag
                      :closable="!loading.main"
                      v-for="(filter, i) in document_filters_tags"
                      :key="i"
                      @close="removeFilter(filter,'document_filters_tags'); goSearch()"
                      closable
                      size="mini"
                      type="primary">
                      {{`${filter.descripcion.replace(/_|#|-|@|<>/g, ' ')} ${filters_operator.find(f => f.id == filter.comparador).operator} ${filter.value}`}}
                    </el-tag>
                  </div>
                </div>
              </div>

              <!-- FILTRO - fechas -->
              <div class="filter-input">
                <span>Fechas</span>
                <div class="filters-date">
                  <el-select
                    v-model="filtro_fecha.select"
                    size="small"
                    class="select-dates">

                    <el-option
                    style="min-width: 180px;"
                    v-for="(date, i) in filters_date"
                    :key="i"
                    :label="date.placeholder"
                    :value="date.key" />
                  </el-select>

                  <el-date-picker
                    size="small"
                    v-model="filtro_fecha.date"
                    :picker-options="{firstDayOfWeek: 1}"
                    type="daterange"
                    align="right"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    start-placeholder="Desde"
                    end-placeholder="Hasta"
                    @change="saveFilterFecha(); goSearch()">
                  </el-date-picker>
                </div>
              </div>

              <!-- Etiquetas -->
              <div class="filter-input">
                <span>Etiquetas</span>
                <div class="filter-input-content">
                  <el-input
                    size="small"
                    style="margin-bottom: 5px"
                    placeholder=""
                    :disabled="loading.main"
                    v-model="document_filters_etiquetas_value"
                    @keyup.enter.native="handleInputConfirmEtiqueta"/>
                  <template v-if="document_filters_etiquetas.length">
                    <el-tag
                      size="mini"
                      type="info"
                      v-if="loading.main">
                      Limpiar etiquetas
                    </el-tag>
                    <el-tag
                      v-else
                      size="mini"
                      type="danger"
                      style="cursor: pointer"
                      @click="document_filters_etiquetas = []; goSearch()">
                      Limpiar etiquetas
                    </el-tag>
                    <el-tag
                      v-for="(tag,i) in document_filters_etiquetas"
                      :key="i"
                      :closable="!loading.main"
                      :disable-transitions="false"
                      size="mini"
                      @close="handleCloseEtiqueta(tag); goSearch()">
                      {{tag}}
                    </el-tag>
                  </template>
                </div>
              </div>

              <!-- Contenido -->
              <div class="filter-input">
                <span>Contenido</span>
                <el-input
                  size="small"
                  placeholder=""
                  :disabled="loading.main"
                  v-model="document_filters_contenido"
                  @keydown.enter.native="goSearch()"
                  />
              </div>

              <!-- Notas -->
              <div class="filter-input">
                <span>Notas</span>
                <el-input
                  size="small"
                  type="text"
                  placeholder=""
                  :disabled="loading.main"
                  v-model="document_filters_notas"
                  @keydown.enter.native="goSearch()" />
              </div>

              <!-- Carpetas -->
              <div class="filter-input">
                <span>Carpeta</span>
                <div style="width: 100%">
                  <el-tooltip effect="dark" :disabled="document_filters_folder == ''" :content="document_filters_folder" placement="top">
                    <el-input
                      style="width: 100%"
                      :disabled="loading.main"
                      @focus.prevent.stop="showDialogFolder"
                      size="small"
                      placeholder=""
                      :readonly="true"
                      v-model="document_filters_folder">
                        <el-button
                        :disabled="loading.main"
                        v-if="document_filters_folder != ''"
                        @click="document_filters_folder = ''; goSearch()"
                        slot="append"
                        icon="el-icon-close"/>
                      </el-input>
                  </el-tooltip>
                </div>
              </div>

              <div class="filter-input" style="justify-content: flex-end; flex-flow: row">
                <el-button plain @click="showGroupedFilters = false">Cancelar</el-button>
                <el-button type="primary" icon="el-icon-search" @click="goSearch()">Buscar</el-button>
              </div>

          </div>
        </div>

        <el-tag
          v-if="filters_tags && filters_tags.length || ((colecciones_selected !== '' || esquema_selected !== '') && !$route.params.propiedad && $route.params.propiedad !== 'esquema') || (document_filters_etiquetas.length && viewconfig && viewconfig.main_filters_grouped)"
          @click="removeFilters('filters_tags'); filtro_fecha.date = []; document_filters_etiquetas = []; goSearch()"
          size="mini"
          type="danger"
          style="cursor: pointer">
          Limpiar filtros
        </el-tag>
        <template>

          <!-- Tags coleccion / documento -->
          <el-tag
            v-if="((colecciones_selected !== '' || esquema_selected !== '') && !$route.params.propiedad && $route.params.propiedad !== 'esquema')"
            size="mini"
            type="primary"
            style="cursor: pointer"
            closable
            @close="colecciones_selected = ''; esquema_selected = ''; document_filters_tags = []; goSearch()">
            {{getColeccionFilterName}}
          </el-tag>

          <!-- Tags filtros comunes -->
          <el-tag
            v-for="(filter, i) in filters_tags"
            :key="i"
            @close="removeFilter(filter,'filters_tags'); goSearch()"
            closable
            size="mini"
            type="primary">

            <template v-if="filter.hasOwnProperty('dates')">
              {{`
                ${filters_date.find(f => f.key == filter.select).placeholder}
                (${moment(filter.dates[0],'YYYY/MM/DD').format('DD/MM/YYYY')} - ${moment(filter.dates[1],'YYYY/MM/DD').format('DD/MM/YYYY')})
              `}}
            </template>
            <template v-else>
              {{`
                ${filters_search.find(f => f.key == filter.select).placeholder}
                ${filters_operator.find(f => f.id == filter.comparador).operator}
                ${filter.value}
              `}}
            </template>

          </el-tag>
        </template>
        <!-- Tags etiquetas (solo con viewconfig.main_filters_grouped) -->
        <template v-if="document_filters_etiquetas.length && viewconfig && viewconfig.main_filters_grouped">
          <el-tag
            v-for="(tag,i) in document_filters_etiquetas"
            :key="i"
            :closable="!loading.main"
            :disable-transitions="false"
            size="mini"
            @close="handleCloseEtiqueta(tag); goSearch()">
            {{tag}}
          </el-tag>
        </template>

      </section>

      <!-- VISTA SEARCH (BUSCADOR) -->
      <div :class="['listado', viewTypeSearch]" v-if="!error && data && data.content && data.content.length">

        <div class="files" v-if="viewTypeSearch === 'show-table'">
          <el-table
            ref="filterTable"
            :data="tableData"
            height="100%"
            style="width: 100%"
            @row-click="(row, column,event) => openDetail(row.document)">

            <el-table-column
              prop="checkbox"
              label=""
              width="40"
            >
            <template slot-scope="scope">
              <el-checkbox
                :value="scope.row.checkbox"
                @change="selectDocument(scope.row.document.id)"/>
            </template>
            </el-table-column>

            <el-table-column
              prop="src"
              label=""
              width="40"
            >
            <template slot-scope="scope">
              <img
                style="width: 20px"
                :src="scope.row.src"
                @click.stop.prevent="downloadFile(false,scope.row.document)"/>
            </template>
            </el-table-column>

            <el-table-column
              prop="descripcion"
              label="Descripción">
            </el-table-column>

            <el-table-column
              prop="ubicacion"
              label="Ubicacion">
            </el-table-column>

            <el-table-column
              prop="tag"
              label=""
              width="180">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.tag"
                  size="small"
                  :type="scope.row.tag.color">{{scope.row.tag.value}}</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <template v-else>
          <ul :class="['files']">
            <li v-for="(document,i) in data.content" :key="i">

              <div class="file-preview"></div>
              <div class="content">
                
                <el-checkbox
                  :value="documentsChecked.includes(document.id)"
                  @change="selectDocument(document.id)"/>

                <div @click.stop.prevent="openDetail(document)">
                  <img
                    class="el-icon-document"
                    :src="getImageFileByDescription(document.descripcion)"
                    @click.stop.prevent="downloadFile(false,document)"/>

                  <div class="desc">
                    <p>{{document.descripcion}}</p>
                    <span>{{document.ubicacion}}</span>
                    <el-tag
                      v-if="!['', null, '0000-00-00', undefined].includes(selectListTag.select ? formatListTag(document).value : document.esquema.descripcion)"
                      size="small"
                      :type="formatListTag(document).color">
                        {{ formatListTag(document).value.replace(/_|#|-|@|<>/g, ' ') }}
                    </el-tag>
                  </div>

                  <el-tag
                    v-if="!['', null, '0000-00-00', undefined].includes(selectListTag.select ? formatListTag(document).value : document.esquema.descripcion)"
                    size="small"
                    :type="formatListTag(document).color">
                      {{ formatListTag(document).value.replace(/_|#|-|@|<>/g, ' ') }}
                  </el-tag>
                </div>
              </div>
            </li>
          </ul>
        </template>

        <footer>

          <!-- Boton descargar archivos seleccionados -->
          <el-button-group v-if="documentsChecked.length">
            <el-button
              :style="{'visibility': documentsChecked.length ? 'visible' : 'hidden'}"
              type="primary"
              size="mini"
              icon="el-icon-download"
              @click="downloadFile(true, null)">Descargar</el-button>
            <el-button size="mini" plain @click="documentsChecked = []">Cancelar</el-button>
          </el-button-group>

          <!-- Selector del tag del listado -->
          <el-button-group v-else>
            <el-select
            v-model="selectListTag.select"
            size="mini"
            style="margin-right: 5px;max-width: 150px">
              <el-option
                v-for="item in selectListTag.options.filter(f => !['fechas_documento','colecciones'].includes(f.key))"
                :key="item.tagKey"
                :label="item.placeholder"
                :value="item.tagKey">
              </el-option>
            </el-select>

            <!-- Tipo de vista -->
            <el-select v-model="viewTypeSearch" size="mini" style="width: 110px">
              <el-option key="lista" label="Lista" value="show-list"/>
              <el-option key="cuadricula" label="Cuadricula" value="show-menu"/>
              <el-option key="tabla" label="Tabla" value="show-table"/>
            </el-select>
          </el-button-group>

          <!-- Paginacion -->
          <el-pagination
            layout="prev, pager, next"
            :current-page.sync="pagination.currentPage"
            :page-size="pagination.perPage"
            :total="pagination.totalResults"
            @current-change="search()">
          </el-pagination>

          <!-- Ordenable -->
          <div class="ordenable">
            <el-select
              v-model="selectOrdenable.select"
              placeholder="Ordenar por"
              size="mini"
              style="max-width: 126px">
              <el-option
                v-for="item in selectOrdenable.options.filter(f => !['fechas_documento','colecciones'].includes(f.key))"
                :key="item.key"
                :label="item.placeholder"
                :value="item.key">
              </el-option>
            </el-select>
            <el-select
              v-model="selectOrdenable.type"
              placeholder="Select"
              size="mini"
              style="max-width: 80px">
              <el-option
                v-for="item in selectOrdenable.types"
                :key="item.key"
                :label="item.placeholder"
                :value="item.key">
              </el-option>
            </el-select>
          </div>

        </footer>
      </div>
      <div style="margin: 15px" v-else>

        <el-alert
          v-if="error"
          type="error"
          description="Ha ocurrido un error, prueba a recargar la página"
          center
          :closable="false"/>

        <div v-else-if="!loading.main" class="no-data">

          <template v-if="data.content && someFilter">
            <img :src="require('@/assets/no_data.svg')" />
            <p class="danger">No hay información que mostrar</p>
            <p>Modifica los filtros para obtener más resultados</p>
          </template>
          <template v-else>
            <img :src="require('@/assets/init_data.svg')" />
            <p>Selecciona algún filtro para obtener resultados</p>
          </template>

        </div>
      </div>

    </main>

    <!-- Detalle -->
    <Detail
    v-if="detail && viewconfig && viewconfig.detail"
    :detail="detail"
    :esquemas="esquema_data"
    :icon="getImageFileByDescription(detail.descripcion)"
    @expand="val => detailExpand = val"
    @close="detail = false; detailExpand = false"
    @fileDeleted="fileDeleted"
    @saveWorkflow="goSearch()"
    @savePropiedades="goSearch()"
    :showClose="true"
    :visor="true"
    :filterSearch="filters_search"
    />

    <!-- Capa de fondo traslucida -->
    <div class="back-overlay" @click="clickBackOverlay(); detail = false"></div>

    <!-- Modal filtro colecciones / esquema -->
    <el-dialog
      class="full-height dialog-buttons"
      title="Selector de tipo de documento"
      :visible.sync="dialogColection.open">
      <div class="coleccion_dialog">

        <FilterCollectionsSchemes
          :colecciones="colecciones_data"
          :esquemas="esquema_data"
          @handleColectionType="handleColectionType"
          @handleDocumentType="handleDocumentType" />

      </div>
    </el-dialog>

    <!-- Modal tree carpetas -->
    <el-dialog
      class="full-height"
      title="Selector carpetas"
      :visible.sync="dialogFolder.open"
      @close="resetDialogFolder()"
      @opened="$refs.folderFilter.focus()">
      <div
      v-if="dialogFolder.open"
      style="min-height: 300px; width: 100%;"
      v-loading="dialogFolder.loading">

        <el-alert
          v-if="dialogFolder.error"
          title="Error al obtener carpetas"
          :closable="false"
          center
          type="error">
        </el-alert>

        <template v-else>
          <el-input
            ref="folderFilter"
            prefix-icon="el-icon-search"
            style="margin-bottom: 15px"
            size="small"
            placeholder="Busca una ubicación"
            @input="(val) => $refs.tree.filter(val)"
            v-model="dialogFolder.filterText">
          </el-input>

          <el-tree
            show-checkbox
            class="filter-tree"
            :check-strictly="true"
            :data="dialogFolder.data"
            :filter-node-method="filterFolderNode"
            :props="dialogFolder.defaultProps"
            @check-change="folderCheckChange"
            ref="tree">
          </el-tree>
        </template>
      </div>
    </el-dialog>

    <!-- Modal metadatos -->
    <el-dialog
      class="full-height dialog-buttons"
      title="Selector de metadato"
      :visible.sync="dialogFilterProperty.open"
      @close="resetDialogFolder()">

      <div class="content-dialog-property" v-if="documentTypeSelect">
        <masonry
          :cols="{default: 3, 991: 3, 768: 1}"
          :gutter="15">

          <ul
            class="list"
            v-for="group in documentTypeSelect.grupos"
            :key="group.descripcion">
            <li>{{group.descripcion}}</li>
            <li
              @click="document_filters_property = item.id; dialogFilterProperty.open = false"
              v-for="item in group.estructura"
              :key="item.id">
              <i class="el-icon-arrow-right"></i>
              {{item.descripcion.replace(/_|#|-|@|<>/g, ' ')}}
            </li>
          </ul>

        </masonry>
      </div>

    </el-dialog>

    <!-- Modal listado de valores del filtro de query params -->
    <el-dialog
      :show-close="false"
      :visible.sync="dialogListas.open"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      class="full-height dialog-buttons"
      :title="`Selecciona ${queryparams.filter}`">

      <el-input
        size="small"
        :placeholder="`Buscar ${queryparams.filter}`"
        style="margin-bottom: 20px"
        v-model="dialogListas.search"
        prefix-icon="el-icon-search"/>

      <ul class="list" style="width: 100%" v-if="valoresListasFiltradas.length">
        <li></li>
        <li
          v-for="valor in valoresListasFiltradas"
          :key="valor.id"
          @click="dialogListas.open = false; $router.push({ path: `/SiDMS.drive/${queryparams.filter}/${valor.id}` })">
          <i class="el-icon-arrow-right"></i>
          {{valor.descripcion.replace(/_|#|-|@|<>/g, ' ')}}
        </li>
      </ul>
      <el-alert
        v-else
        title="Sin datos"
        type="info"
        :closable="false"></el-alert>

    </el-dialog>

  </div>
</template>

<script>
import {
  getUrl,
  getElementoBusqueda,
  descargarElemento,
  descargarElementos,
  getCarpetas,
  getEsquemas,
  getColecciones,
  getListasEstructura,
  getExpedientes,
  cargarUsuario,
  redireccionLogin,
  getListaEquivalencias,
  getExpedientesTipo,
  getBusquedaPersonalizada
} from './api/api.js'

import Detail from './components/Detail.vue'
import FilterCollectionsSchemes from './components/FilterCollectionsSchemes.vue'
import Preview from './components/Preview.vue'
import Navbar from './components/Navbar.vue'
import HeaderViewType from './components/Header/HeaderViewType.vue'
import moment from 'moment'

import {
  debug,
  types_input,
  filters_operator,
  filters_date
} from './config.js'

import { init } from './api/api.js'

export default {
  name: 'Search',
  components: {
    Detail,
    FilterCollectionsSchemes,
    Preview,
    Navbar,
    HeaderViewType
  },
  data() {

    return {
      moment,

      filters_operator,
      types_input,

      // Filtros generales
      filters_search: [],
      filters_date,
      filters_tags: [],

      // Data Buscador
      data: [],
      error: false,

      // Filtros especificos
      document_filters: [],
      document_filters_error: false,
      document_filters_property: '',
      document_filters_property_input: {
        value: '',
        comparador: 1
      },
      document_filters_contenido: '',
      document_filters_descripcion: '',
      document_filters_notas: '',
      document_filters_folder: '',
      document_filters_etiquetas: [],
      document_filters_etiquetas_value: '',
      document_filters_tags: [],
      dialogFilterProperty: {
        open: false
      },

      // Filtros comunes
      filtro_comun: {
        select: 'description', // Por defecto 'descripcion'
        comparador: 6, // Por defecto 'contiene'
        value: ''
      },

      // Filtros date
      filtro_fecha: {
        select: 'propiedad_modificado', // Por defecto modificado
        date: []
      },

      // Filtro query params
      filtro_query: false,
      queryparams: {
        view: '',
        filter: '',
        id: ''
      },

      // Loading
      loading: {
        main: false,
        aside: false,
        full: false
      },

      // Paginacion
      pagination: {
        currentPage: 1,
        totalResults: 0,
        perPage: 50
      },

      // Selector para ordenar
      selectOrdenable: {
        options: [
          //...filters_search,
          ...filters_date,
          {
            key: 'ubicacion',
            placeholder: 'Ubicación'
          }, {
            key: 'extension',
            placeholder: 'Tipo archivo'
          }, {
            key: 'nombre',
            placeholder: 'Nombre'
          }
        ],
        select: 'nombre',
        types: [{
          key: 'A',
          placeholder: 'ASC'
        }, {
          key: 'D',
          placeholder: 'DESC'
        }],
        type: 'A'
      },

      // Documentos seleccionados para descargar
      documentsChecked: [],

      // Detalle
      detail: false,
      detailExpand: false,

      // Esquemas
      esquema_error: false,
      esquema_data: [],
      esquema_selected: '',

      // Colecciones
      cache_error: false,
      cache_cachered: false,
      colecciones_error: false,
      colecciones_data: [],
      colecciones_selected: '',

      // Listas estructura
      listas_data: [],

      // Carpetas
      dialogFolder: {
        open: false,
        data: [],
        loading: false,
        error: false,
        filterText: '',
        defaultProps: {
          children: 'hijos',
          label: 'nombre'
        }
      },

      // Modal esquemas - colecciones
      dialogColection: {
        open: false
      },

      // Estilo main
      main: {
        width: 0
      },

      // Estilo aside
      openAside: false,

      // Selector de tag para el listado
      selectListTag: {
        select: 'tipo_documento__id',
        options: [
          //...filters_search,
          ...filters_date
        ]
      },

      // Tipo de vista actual
      viewType: 'buscador',

      // Control error al obtener un documento
      document_error: false,

      // Modal de listas
      dialogListas: {
        open: false,
        valores: [],
        search: ''
      },

      // Usuario logueado
      user: null,

      // Tipo de visualizacion de resultados [lista, cuadricula, tabla]
      viewTypeSearch: 'show-list',

      // Configureacion de visualizacion
      viewconfig: null,

      // Conjunto de filtros agrupados
      showGroupedFilters: false

    }
  },
  computed: {
    // Comprueba si esta dentro de un iframe
    insideIframe() {
      return window.top !== window.self;
    },
    // Tipo de documento seleccionado
    documentTypeSelect() {
      return this.esquema_data.find(f => f.id == this.esquema_selected)
    },
    // Todas las propiedades por tipo de documento
    propertiesByDocumentType() {
      return this.documentTypeSelect.grupos ? this.documentTypeSelect.grupos.reduce((acum, obj) => {
        obj.estructura.forEach(obj => {
          acum.push(obj)
        })
        return acum
      }, []) : []
    },
    // Indica si se esta filtrando por algo
    someFilter() {
      return !!(
        this.esquema_selected !== '' ||
        this.document_filters_contenido !== '' ||
        this.document_filters_notas !== '' ||
        this.document_filters_etiquetas.length ||
        this.document_filters_tags.length ||
        this.document_filters_folder !== '' ||
        this.filters_tags.length
      )
    },
    getColeccionFilterName() {

      let name = []

      if (this.esquema_data.length && this.colecciones_data.length) {

        if (this.colecciones_selected) {
          name.push(this.colecciones_data.find(f => f.id == this.colecciones_selected).nombre)
        }

        if (this.esquema_selected) {
          name.push(this.esquema_data.find(f => f.id == this.esquema_selected).descripcion.replace(/_|#|-|@|<>/g, " "))
        } else {
          name.push('Todos')
        }

      } else {
        name.push('Todos')
      }

      return name.join(' / ')
    },
    getFilterSearch() {
      return this.filters_search.filter(f => f.placeholder !== `${this.queryparams.filter}`)
    },
    titlePortal() {

      let title = 'Portal de documentación'

      if (this.queryparams.id && this.queryparams.filter) {

        if (this.queryparams.filter == 'esquema' && this.esquema_data.length) {

          title = `Portal de ${this.esquema_data.find(f => f.id == this.queryparams.id).descripcion.replace(/_|#|-|@|<>/g, ' ')}`

        } else {

          title = `Portal de ${this.queryparams.filter} ${this.queryparams.id}`

        } 

      }

      return title
    },
    valoresListasFiltradas() {
      return this.dialogListas.valores.filter(f => f.descripcion.toLowerCase().includes(this.dialogListas.search.toLowerCase()))
    },
    // Modo tabla para visualizar documentacion
    tableData () {
      return this.data.content.map((document) => {
        
        let obj = {
          document,
          checkbox: this.documentsChecked.includes(document.id),
          src: this.getImageFileByDescription(document.descripcion),
          descripcion: document.descripcion,
          ubicacion: document.ubicacion,
          tag: null
        }

        if (!['', null, '0000-00-00', undefined].includes(this.selectListTag.select ? this.formatListTag(document).value : document.esquema.descripcion)) {
          let listTag = this.formatListTag(document)
          obj.tag = {
            color: listTag.color,
            value: listTag.value.replace(/_|#|-|@|<>/g, ' ')
          }
        }

        return obj
      })
    }
  },
  watch: {
    $route(from, to) {
      this.queryparams = {
        filter: '',
        id: ''
      }
      this.init()
    },
    'filtro_fecha.select'() {
      this.filtro_fecha.date = []
    },
    'expedientes_filtro.select'() {
      this.expedientes_filtro.date = []
    },
    'main.width'(width) {
      if (width <= 860) {
        this.openAside = false
      }
    },
    'selectOrdenable.select'() {
        this.goSearch()
    },
    'selectOrdenable.type'() {
        this.goSearch()
    }
  },
  created() {
    init()
  },
  mounted() {
    this.init()
  },
  methods: {
    validParams() {

      // Comprobar propiedad
      if (this.$route.query.propiedad) {

        let isBase64 = require('is-base64');

        // Comprobar si es un token
        if (isBase64(this.$route.query.propiedad)) {

          this.queryparams.filter = {
            token: this.$route.query.propiedad
          }

          // Busqueda con token
          this.goSearch()

        }
        
        // Comprobar si es un tipo de filtro
        else {

          if (['esquema',...this.filters_search.map(m => m.placeholder)].includes(this.$route.params.propiedad)) {
            this.queryparams.filter = this.$route.params.propiedad

            // Validar id
            if (this.$route.params.id) {
              this.queryparams.id = this.$route.params.id
            }

          } else {
            this.$router.push({path: `/SiDMS.drive`})
          }

        }
        
      }
      
    },

    // Inicializar
    async init() {
      
      await this.fetchCacheData() // Peticion esquemas y colecciones

      this.validParams() // Validar parametros

      if(this.queryparams.filter == 'esquema' && this.queryparams.id) {

        let esquema_id = this.queryparams.id
        let esquema_exist = this.esquema_data.find(f => f.id == esquema_id)

        if (esquema_exist) {
          this.esquema_selected = esquema_exist.id
          this.colecciones_selected = esquema_exist.coleccion_esquema__id

          this.goSearch()
        }
      }

      this.main.width = this.$refs.main.offsetWidth;
      this.main.height = this.$refs.main.offsetHeight;

      // Comprobar modal de listas
      if (this.queryparams.filter && !this.queryparams.id) {
        let existListaFilter = this.filters_search.find(f => f.placeholder == this.queryparams.filter)

        if (existListaFilter) {
          let existLista = existListaFilter.lista
          let valores = this.listas_data.find(f => f.id == existLista).valores
          if (valores.length > 1) {
            this.dialogListas.valores= valores
            this.dialogListas.open = true
          } else {
            this.$router.push({ path: `/SiDMS.drive/${this.queryparams.filter}/${valores[0].id}` })
          }
        }
      }
    },
    async fetchCacheData() {

      if (this.cache_cachered) return

      this.cache_cachered = false
      this.cache_error = false
      this.loading.full = true

      try {

        let resp = null
        if (debug) {

          await new Promise((resolve, reject) => setTimeout(() => { return resolve()}, 2000))
          resp = await Promise.all([
            await ( await fetch('/test_local/esquemas.json', { method: 'GET' })).json(),
            await ( await fetch('/test_local/colecciones.json', { method: 'GET' })).json(),
            await ( await fetch('/test_local/listaestructura.json', { method: 'GET' })).json(),
            await ( await fetch('/test_local/respuestausuario.json', { method: 'GET' })).json(),
            await ( await fetch('/test_local/listaequivalencias.json', { method: 'GET' })).json(),
            await ( await fetch('/test_local/viewConfig.json', { method: 'GET' })).json()
          ])

        } else {

          resp = await Promise.all([
             getEsquemas(),
             getColecciones(),
             getListasEstructura({
              busqueda: {
                query: '',
                numeroPaginas: 100,
                pagina: 1,
                orden: "nombreA"
              }
            }),
             cargarUsuario(),
             getListaEquivalencias(),
             await ( await fetch('/test_local/viewConfig.json', { method: 'GET' })).json()
          ])
        }

        this.esquema_data = resp[0].data
        this.colecciones_data = resp[1].data
        this.listas_data = resp[2].data.content
        this.user = resp[3].data.usuario

        let filters_search = [{
            key: 'ano',
            tagKey: 'ano',
            placeholder: 'Año',
            comparador: 1,
            type: 'number',
            value: ''
          }, {
            key: 'description',
            tagKey: 'descripcion',
            placeholder: 'Descripción',
            comparador: 1,
            type: 'text',
            value: ''
          }, {
            key: 'nombre',
            tagKey: 'nombre',
            placeholder: 'Nombre',
            comparador: 1,
            type: 'text',
            value: ''
          },
          ...resp[4].data.equivalencias.map(m => {
            return {
              ...m,
              tagKey: m.key,
              comparador: 1,
              type: 'text',
              value: ''
            }
          })
        ]
        this.filters_search = filters_search

        this.selectListTag.options.push(...filters_search)
        this.selectOrdenable.options.push(...filters_search)

        if (this.$route.query) {
          this.viewconfig = this.$route.query.view ? resp[5][resp[5].hasOwnProperty(this.$route.query.view) ? this.$route.query.view : 'full'] : resp[5]['full']
        }

        this.cache_cachered = true

      } catch(err) {
        this.cache_error = err
      }

      this.loading.full = false
    },

    getEsquemasByColeccion(id) {
      return this.esquema_data.filter(f => f.coleccion_esquema__id == id)
    },

    selectEsquemaFromExpedientes(esquema_id, coleccion_id) {

      this.viewType = "buscador"
      this.detail = false

      this.handleDocumentType({
        esquema: esquema_id,
        coleccion: coleccion_id
      })

      this.goSearch()
    },

    // Realizar busqueda
    async search() {

      this.error = false
      this.loading.main = true

      try {

        let data = {}

        if (this.queryparams.filter.hasOwnProperty('token')) {

          // BUSQUEDA CON TOKEN
          data = {
            "orden": `${this.selectOrdenable.select}${this.selectOrdenable.type}`,
            "pagina": this.pagination.currentPage,
            "token": this.queryparams.filter.token
          }

          let resp = null
          resp =  await getBusquedaPersonalizada(data)

          this.data = resp.data
          this.pagination.totalResults = resp.data.totalResults

        } else {

          // BUSQUEDA NORMAL
          let propiedades_comunes = this.filters_tags
          .filter(f => f.value !== '' && !f.hasOwnProperty('dates'))
          .map(f => {
            return {
              value: f.value,
              name: f.select,
              comparador: f.comparador
            }
          })

          // Añadir filtro query
          let propiedades_query = []
          if(this.queryparams.filter && this.queryparams.id && this.queryparams.filter !== 'esquema') {
            propiedades_query.push({
              value: this.filters_search.find(fs => fs.placeholder == this.queryparams.filter).key,
              comparador: 1,
              name: this.queryparams.id
            })
          }

          let propiedades = [
            ...propiedades_comunes,
            ...propiedades_query
          ]

          const esquema = this.esquema_selected
          const metadatos = this.document_filters_tags
          .filter(f => f.value !== '')
          .map(m => {
            const comparador = this.filters_operator.find(f => f.id == m.comparador).label
            return {
              id: m.id,
              esquema,
              comparador,
              values: (comparador == 'Entre') ? m.value.split(',') : [m.value,""]
            }
          })

          const propiedades_fecha = {}

          this.filters_tags
          .filter(f => f.hasOwnProperty('dates'))
          .forEach(obj => {
            propiedades_fecha[`${obj.select}_start`] = obj.dates[0]
            propiedades_fecha[`${obj.select}_end`] = obj.dates[1]
          })

          data = {
            "busqueda": {
              ...propiedades_fecha,
              "coleccion_esquema__id": this.colecciones_selected,
              "ubicacion": this.document_filters_folder,
              "carpeta": "global",
              "tipoBusqueda": "busqueda",
              "orden": `${this.selectOrdenable.select}${this.selectOrdenable.type}`, // Orden del resultado
              "pagina": this.pagination.currentPage,
              "numeroPaginas": this.pagination.perPage,
              "mostrar": "D", // "D"ocumentos o  "C"arpetas, si no pones nada por defecto saldrán Documentos
              "contenido": {
                "contenido": this.document_filters_contenido,
                "exacta": false
              },
              "esquemaId" : this.esquema_selected,
              "propiedades": propiedades,
              "metadatos": metadatos,
              "notas":{
                "nota": "",
                "exacta":false,
                "notas": this.document_filters_notas
              },
              "etiquetas":{
                "etiquetas": this.document_filters_etiquetas,
                "exacta":false
              }
            },
            "todo": true
          }

          console.log(data)

          let resp = null
          if (debug) {

            await new Promise((resolve, reject) => setTimeout(() => { return resolve()}, 2000))
            resp = await (await fetch('/test_local/elemento_busqueda.json', {
              method: 'GET'
            })).json()

          } else {

            resp =  await getElementoBusqueda(data)
          }

          this.data = resp.data
          this.pagination.totalResults = resp.data.totalResults
        }

        let div_list = document.getElementsByClassName('files')
        if (div_list && div_list.length) div_list[0].scrollTop = 0

      } catch (err) {
        this.error = err
      }

      this.loading.main = false

      this.clickBackOverlay()
    },
    async goSearch() {

      this.pagination.currentPage = 1
      await this.search()
      
      this.detail = false
      this.showGroupedFilters = false
    },

    // Gestionar filtros
    saveFilter($event, filter, key) {

      if (key == 'document_filters_tags') {

        if (this.document_filters_property == '' || this.document_filters_property_input.value == '') return

        filter = {
          ...this.document_filters_property_input,
          ...this.propertiesByDocumentType.find(f => f.id == this.document_filters_property)
        }
      }

      filter.date = new Date().getTime()
      this[key].push(JSON.parse(JSON.stringify(filter)))
      filter.value = ''

      if (key == 'document_filters_tags') {
        this.document_filters_property_input = {
          value: '',
          comparador: 1
        }
        this.document_filters_property = ''
      }
    },
    removeFilter(filter, key) {
      let filterIndex = this[key].findIndex(f => f.date == filter.date)
      if (filterIndex >= 0) {
        this[key].splice(filterIndex, 1)
      }
    },
    removeFilters(key) {
      this[key] = []

      this.document_filters_tags = []

      if ((this.colecciones_selected !== '' || this.esquema_selected !== '') && !(this.$route.params.propiedad && this.$route.params.propiedad == 'esquema')) {
        this.colecciones_selected = ''
        this.esquema_selected = ''
      }
    },
    saveFilterFecha() {

      let dates = this.filtro_fecha.date
      let select = this.filtro_fecha.select

      if (!dates || !dates.length || !select) return

      let selectExist = this.filters_tags.findIndex(f => f.select == select)
      if (~selectExist) this.filters_tags.splice(selectExist, 1)

      this.filters_tags.push({
        date: new Date().getTime(),
        select,
        dates
      })
    },
    saveFilterFechaExpedientes() {
      let dates = this.expedientes_filtro.date
      let select = this.expedientes_filtro.select

      if (!dates || !dates.length || !select) return

      let selectExist = this.expedientes_filtro_tags.findIndex(f => f.select == select)
      if (~selectExist) this.expedientes_filtro_tags.splice(selectExist, 1)

      this.expedientes_filtro_tags.push({
        date: new Date().getTime(),
        select,
        dates
      })

      this.goSearch()
    },

    // Descarga de archivo
    selectDocument(document_id) {
      let exist = this.documentsChecked.findIndex(f => f == document_id)
      if (~exist) {
        this.documentsChecked.splice(exist, 1)
      } else {
        this.documentsChecked.push(document_id)
      }
    },
    async downloadFile(multiple = false, document) {
      this.loading.main = true

      try {

        let resp = null
        if (multiple) {
          let data = {ids: this.documentsChecked}
          resp = await descargarElementos(data)
          var blob = new Blob([resp.data], {type: "application/zip"});
          var objectUrl = URL.createObjectURL(blob);
          this.openwindow(objectUrl);
        } else {
          resp = await descargarElemento([document.id])

          location.href = getUrl() + 'acceso/externo/?token=' + resp.data.token + '&id=' + resp.data.fichero
        }

      } catch(err) {
        console.log(err)
        this.$notify.error({
          title: 'Error',
          message: 'Error al realizar la descarga'
        });
      }

      this.loading.main = false

      if (this.documentsChecked.length) this.documentsChecked = []
    },

    // Cambiar tipo de documento
    handleDocumentType({esquema, coleccion}) {

      this.document_filters_tags = []
      this.esquema_selected = esquema
      this.document_filters_property = ''

      this.colecciones_selected = coleccion
      this.dialogColection.open = false

      this.goSearch()
    },
    addDocumentFilterProperty(property) {

      this.document_filters_property = property
      this.document_filters_property_input = {
        value: '',
        comparador: 1
      }
    },

    // Cambiar coleccion
    handleColectionType({ coleccion}) {
      this.esquema_selected = ''
      this.colecciones_selected = coleccion
      this.dialogColection.open = false
      this.goSearch()
    },

    // Control de etiquetas
    handleCloseEtiqueta(tag) {
      this.document_filters_etiquetas.splice(this.document_filters_etiquetas.indexOf(tag), 1);
    },
    handleInputConfirmEtiqueta() {
      let inputValue = this.document_filters_etiquetas_value;
      if (inputValue && !this.document_filters_etiquetas.includes(inputValue)) {
        this.document_filters_etiquetas.push(inputValue);
      }
      this.document_filters_etiquetas_value = '';

      this.goSearch()
    },

    // Abrir detalle de ficha
    openDetail(document) {
      if (this.viewconfig) {
        if (this.viewconfig.detail) {
          this.detail = document
        } else {
          this.downloadFile(false,document)
        }
      }
    },

    // Abrir modal de carpetas
    async showDialogFolder() {

      if (this.dialogFolder.data.length) {
        this.dialogFolder.open = true
        return
      }

      this.dialogFolder.open = true
      this.dialogFolder.loading = true
      this.dialogFolder.error = false

      try {

        let resp = null
        if (debug) {

          resp = await (await fetch('/respuestaArbolCarpetas.json', {
            method: 'GET'
          })).json()

        } else {

          resp = await getCarpetas()
        }

        this.dialogFolder.data = resp.data

      } catch (err) {
        this.dialogFolder.error = err
      }

      this.dialogFolder.loading = false
    },
    folderCheckChange(node, selected) {
      if (node && selected) {
        this.document_filters_folder = node.ubicacion == '' ? node.nombre : node.ubicacion
      }
      this.resetDialogFolder()

      this.goSearch()
    },
    filterFolderNode(value, data) {
      if (!value) return true;
      return data.nombre.indexOf(value) !== -1;
    },
    resetDialogFolder() {
      this.dialogFolder.open = false
      this.dialogFolder.loading = false
      this.dialogFolder.error = false
      this.dialogFolder.filterText = ''
    },

    // Imagenes por tipo de documento
    getImageFileByDescription(txt) {

      let exp = /\.([0-9a-z]+)(?:[\?#]|$)/i

      let file = null
      try {
        file = require(`@/assets/files/fi-${txt.match(exp)[1]}.svg`)
      } catch(err) {
        file = require(`@/assets/files/any-file.png`)
      }

      return file

    },

    // Archivo eliminado
    fileDeleted() {
      this.detail = false
      this.goSearch()
    },

    goToAdmin() {
      this.openwindow('/admin', '_blank')
    },

    // Redimension de main
    onResizeMain({ width, height }) {
      this.main.width = width
      this.main.height = height
    },
    clickBackOverlay() {
      this.openAside = false
    },

    // Formatea el valor del tag del listado
    formatListTag(document) {

      let value = this.selectListTag.select && this.selectListTag.select !== 'tipo_documento__id' ? document[this.selectListTag.select] : document.esquema.descripcion

      let newValue = value || ''
      let color = 'primary'

      let option = this.selectListTag.options.find(f => f.tagKey == this.selectListTag.select)

      if (option && !['', null, '0000-00-00', undefined].includes(value)) {

        if (option.lista) {

          let lista = this.listas_data.find(f => f.id == option.lista)
          let valueExist = lista.valores.find(f => f.id == value)
          if (valueExist) {
            newValue = valueExist.descripcion
          } else if(typeof value === 'number') {
            newValue = ''
          }

        } else if (option.format) {

          newValue = moment(value, option.format).format('DD/MM/YYYY')

          // Solo en fecha caducidad tener en cuenta color
          if (option.tagKey == 'fecha_caducidad') {

            color = this.getColorForFechaCaducidad(value, option.format)

          }

        }
      }

      return {
        value: newValue.toString(),
        color
      }
    },

    getColorForFechaCaducidad(value, format) {

      let color = 'success'

      if(![null, undefined, '', '0000-00-00'].includes(value)) {

        let diff = moment(value, format).diff(moment(), 'months', true)

        if (diff <= 0) { // a pasado mas de 1 mes
          color = 'danger'
        } else if (diff > 0 && diff < 1) { // Queda menos de un mes
          color = 'warning'
        }
      }

      return color
    },

    outsideFilters() {
      this.showGroupedFilters = false
    }
  }
}
</script>

<style lang="scss">
.search-content {
  height: 100%;
  display: flex;

  &.open-detail {
    .back-overlay {
      display: block;
    }
    section.detail {
      z-index: 999;
    }
  }

  &.open-aside {
    .back-overlay {
      display: block;
    }

    aside {
      transition-duration: 300ms;
      left: 0;
      top: 0;
      z-index: 999;
    }
  }

  aside {
    border-right: 1px solid #dcdfe6;
    display: flex;
    height: 100%;
    flex-flow: column;
    width: 250px;
    min-width: 250px;
    position: relative;
    overflow: hidden;
    background-color: white;
    z-index: 99;
    position: absolute;
    left: -250px;
    top: 0;
    transition-duration: 300ms;

    .ps {
      height: calc(100% - 70px);

      .aside-inner {
        overflow: auto;

        .company {
          display: flex;
          justify-content: center;
          border-bottom: 1px solid #dcdfe6;
          position: relative;
          height: 100px;
          margin-bottom: 35px;

          .company-inner {
            width: 125px;
            height: 75px;
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 2rem;
            color: #989898;
            padding: 15px;
            border-radius: 5px;
            margin-top: 15px;
            position: absolute;
            top: 15px;
            border: 4px solid white;
            box-shadow: #00000073 0px 0px 10px;
            padding: 0px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
        .user-options {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          justify-content: center;
          flex-flow: column;
          p {
            margin: 0px 0px 10px 0px;
            font-size: 0.95rem;
          }
        }

        .filters-date {
          padding: 15px;
          .el-select {
            width: 100%;
            margin-bottom: 5px;
          }
          .el-date-editor {
            flex-grow: 1;
            width: 100%;
            margin-bottom: 5px;
          }
          .el-tag {
            margin: 0px 5px 5px 0px;
          }
        }

        .documents {
          padding: 10px;
          min-width: 180px;
          margin-top: 15px;
          text-align: center;

          span.el-dropdown-link {
            display: flex;
            align-items: center;
            i {
              cursor: pointer;
              font-size: 1.5rem;
              &.el-icon-arrow-down {
                font-size: 1rem!important;
              }
              &.el-icon-document {
                margin-right: 10px;
                color: #a2a2a2;
                font-size: 1.2rem;
              }
            }
          }
        }

        > section.filters {
          padding: 0px 15px 30px 15px;
          form {
            margin-bottom: 20px;
          }
          .el-tag {
            margin: 0px 5px 5px 0px;
          }
        }

        .title-upload {
          position: relative;
          margin-top: 20px;
          border-radius: 10px;
          border: 2px dashed #dcdfe6;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          &:after {
            padding-bottom: 70%;
            content: "";
            display: block;
          }
          &:hover {
            border-color: #C0C4CC!important;
          }
          img {
            width: 40%;
          }
        }
      }
    }

    .button-search {
      background-color: white;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 15px;
      box-shadow: rgba(0, 0, 0, 0.12) 0px 0px 16px;
      > button {
        width: 100%;
      }
      > .el-button-group {
        display: flex;
      }
    }

    @media (min-width: 768px) {
      position: relative;
      left: 0px;
    }
  }

  main {
    display: flex;
    flex-flow: column;
    flex-grow: 1;
    background-color: #fafafa;
    position: relative;
    overflow: hidden;

    section.main-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      h1 {
        font-size: 1.2rem;
        font-weight: 400;
        margin: 15px 15px 0px 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #0000001f;
        text-transform: uppercase;
        > i {
          font-size: 1.5rem;
          padding: 5px 10px 5px 0px;
          cursor: pointer;
          color: #929292;
          display: block;
        }
        @media (min-width: 768px) {
          font-size: 2rem;
        }
      }
      .el-button-group {
        margin: 15px;
      }
    }

    &.sm {
      

      footer {
        flex-flow: column;
          > .el-select,
          > .ordenable {
            margin-bottom: 5px
          }

          .el-pagination {
            order: 3!important;
          }
      }
    }

    @media (min-width: 768px) {
      section.main-header {
        h1 > i {
          display: none!important;
        }
      }
    }

    // Seccion de filtros comunes
    > section.filters {
      margin-top: 15px;
      padding: 0px 15px;
      background-color: #fafafa;

      .filters-content {
        display: flex;
        align-items: center;
        flex-flow: row;
        margin-bottom: 5px;

        > button {
          margin-right: 10px;
        }

        > button,
        > div {
          width: calc(100% / 3);
        }

        .filters-comun {
          display: flex;
          margin-right: 10px;
          flex-grow: 1;

          .select-filter {
            width: 135px;
            flex-shrink: 0;
            input {
              border-radius: 4px 0px 0px 4px;
              border-right: 0px;
            }
          }
          .select-comparador {
            max-width: 48px;
            input {
              border-radius: 0px;
              padding: 0px 10px;
              text-align: center;
            }
            span.el-input__suffix {
              display: none;
            }
          }
          .input-buscador {
            input {
              border-radius: 0px 4px 4px 0px;
              border-left: 0px;
            }
          }
        }

        .filters-date {
          display: flex;
          align-items: center;
          min-width: 130px;

          .el-select {
            flex-shrink: 0;
            width: 135px;

            input {
              border-radius: 4px 0px 0px 4px;
            }
          }
          .el-date-editor {
            flex-grow: 1;
            border-radius: 0px 4px 4px 0px;
          }
        }

        .more-filters-button {
          display: none;
          background-color: white;
          padding: 6px;
          cursor: pointer;
          width: -webkit-fill-available !important;
          max-width: 30px;
          text-align: center;
          color: #a0a0a0;
          border-radius: 3px;
          &:hover {
            background-color: #f1f1f1!important;
            color: #525252!important;
          }
        }

        // Filtros agrupados
        &.filters-content-grouped {
          background-color: white;
          padding: 5px;
          border-radius: 4px;
          width: auto;
          max-width: max-content;
          border: 1px solid #dcdfe6;
          position: relative;
          &.show-grouped-filters {
            border-radius: 4px 4px 0px 0px !important;
            box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
            border: 0px;
            margin: 0px 0px 6px 0px;
            border-bottom: 1px solid #e7e8e8;
          }
          > div {
            width: auto;
          }
          > button {
            display: none;
          }
          > .header-view-type {
            display: none;
          }
          .filters-date {
            display: none;
          }
          .more-filters-button {
            display: block;
          }
          .grouped-filters {
            position: fixed;
            background-color: white;
            width: -webkit-fill-available;
            left: 0px;
            top: 0px;
            bottom: 0px;
            padding: 20px;
            border-radius: 0px 0px 4px 4px;
            box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
            z-index: 2;
            overflow: auto;
            
              .filter-collection {
                display: flex;
                width: 100%;
                justify-content: center;
                margin-bottom: 10px;
              }

              .filter-input {
                display: flex;
                align-items: baseline;
                flex-flow: column;
                padding-bottom: 20px;
                
                &:last-child {
                  padding-bottom: 0px;
                }

                .filter-input-content {
                  flex-grow: 1;
                  width: 100%;

                  > .filter-metadatos {
                    display: flex;
                    margin-bottom: 5px;
                    flex-flow: column;
                    > div {
                      flex-grow: 1;
                      margin-bottom: 5px;
                    }
                    .input-with-select {
                      .el-input-group__prepend {
                        border-radius: 0px;
                        .el-select {
                          width: 55px;
                          .el-input--suffix {
                            .el-input__inner {
                              padding-right: 15px;
                              border-radius: 0px;
                              text-align: center;
                            }
                            .el-input__suffix {
                              display: none !important;
                            }
                          } 
                        }
                      }
                    
                      > input {
                        border-radius: 0px 4px 4px 0px;
                      }
                    }
                    > button {
                      flex-grow: 1;
                    }
                    @media (min-width: 768px) {
                      flex-flow: row;
                      > div {
                        max-width: 300px;
                        flex-grow: 1;
                        margin-bottom: 0px;
                        > div {
                          input {
                            border-radius: 4px 0px 0px 4px;
                            border-right: 0px;
                          }
                        }
                      }
                      > button {
                        margin-left: 10px;
                      }
                    }
                  }
                }

                > .filters-date {
                  display: flex!important;
                  flex-flow: column;
                  > div {
                    width: 100%;
                  }
                  .el-select {
                    margin-bottom: 5px;
                    input {
                      border-radius: 4px;
                    }
                  }
                  .el-date-editor {
                    border-radius: 4px;
                  }
                  @media (min-width: 768px) {
                    flex-flow: row;
                    .el-select {
                      margin-bottom: 0px;
                      max-width: 135px;
                      input {
                        border-radius: 4px 0px 0px 4px;
                      }
                    }
                    .el-date-editor {
                      border-radius: 0px 4px 4px 0px;
                    }
                  }
                }

                > span {
                  width: 90px;
                  flex-shrink: 0;
                  font-size: 13px;
                  color: #8c8c8c;
                  margin-bottom: 5px;
                }

                @media (min-width: 768px) {
                  flex-flow: row;
                  > span {
                    margin-bottom: 0px;
                  }
                }

              }

              @media (min-width: 768px) {
                .filter-collection {
                  display: none;
                }
              }
            
            @media (min-width: 768px) {
              position: absolute;
              top: 43px;
              bottom: unset;
            }
          }
          @media (min-width: 768px) {
            max-width: 100%;
            > button {
              display: block;
            }
            > .header-view-type {
              display: block;
            }
          }
        }

        // Filtro por esquema
        &.filters-esquema {
          padding: 0px!important;
          border: 0px!important;
          background-color: transparent!important;
          box-shadow: none!important;
          button {
            display: none;
          }
          .more-filters-button {
            background-color: transparent!important;
          }
        }
      }

      .el-tag {
        margin: 0px 5px 5px 0px;
      }
    }

    // Tabs de colecciones
    .colecciones_tabs {
      margin: 0px 15px;
    }

    // Listado ficheros
    .listado {
      height: 100%;
      max-height: 100%;
      overflow: hidden;
      display: flex;
      flex-flow: column;

      .files {
        padding: 0px;
        margin: 15px;
        flex-grow: 1;
        overflow: auto;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        background-color: white;
        justify-content: center;

        li {
          padding: 0px 20px 0px 0px;
          //display: flex;
          //align-items: center;
          border-bottom: 1px solid #dcdfe696;
          background-color: white;
          cursor: pointer;
          position: relative;
          list-style: none;
          .file-preview {
            display: none;
          }

          .content {
            display: flex;
            align-items: center;

            > label {
              padding: 0px 5px 0px 10px;
              visibility: visible;
              &.is-checked {
                visibility: visible;
              }
            }

            > div {
              display: flex;
              align-items: center;
              flex-grow: 1;
              min-width: 0;

              .el-icon-document {
                width: 25px;
                padding: 10px 10px 10px 5px;
              }
              .desc {
                flex-grow: 1;
                min-width: 0;
                p {
                  margin: 0px 0px 3px 0px;
                  font-size: 0.9rem;
                  font-weight: 500;
                }
                span {
                  font-size: 0.75rem;
                  color: #606266d1;
                  display: block;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  padding-right: 15px;
                }
                span.el-tag {
                  display: none;
                }
              }
              .el-tag {
                flex-shrink: 0;
              }
            }
          }

          &:hover {
            background-color: #000e2905;
            > label {
              visibility: visible;
            }
          }

          @media(min-width: 768px) {
            > label {
              visibility: hidden;
            }
          }
        }
      }

      &.show-menu {
        .files {
          flex-direction: row;
          display: flex;
          flex-wrap: wrap;
          align-content: baseline;
          border: 0px;
          background-color: transparent;
          li {
            width: 350px;
            margin: 5px;
            padding: 0px !important;
            border: 1px solid #eaecf0;
            border-radius: 4px;
            .file-preview {
              width: 100%;
              height: 100px;
              background-color: #f3f3f3;
              display: block;
            }
            .content {
              padding: 8px 0px;
              > div {
                .desc {
                  > p {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                  }
                  span.el-tag {
                    display: inline-block;
                  }
                }
                span {
                  display: none;
                }
              }
            }
          }
        }
      }

      &.show-table {
        padding: 0px!important;
        .content {
          .td-check {
            width: 50px;
          }
          .td-icon {
            width: 100px;
          }
          .td-desc {
            flex-grow: 1;
          }
          .td-ubicacion {
            width: 40%;
          }
          .td-tag {
            width: 130px;
          }
        }
      }

      footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 15px 15px 15px;

        .el-pagination {
          display: flex;
          justify-content: center;
          background-color: #fafafa;
          order: unset;
          * {
            background-color: transparent;
          }
        }

        .ordenable {
          .el-select {
            &:first-child {
              input {
                border-radius: 4px 0px 0px 4px;
                border-right: 0px;
              }
            }
            &:last-child {
              input {
                border-radius: 0px 4px 4px 0px;
              }
            }
          }
        }
      }
    }

    // Vista de documento
    .documento {
      height: 100%;
      max-height: 100%;
      overflow: hidden;
      display: flex;
      margin: 15px;
      > #preview {
        width: 100%;
        border: 1px solid #dcdfe6;
      }
    }

    &.detailExpand .listado > ul.files > li > .el-tag {
      display: none;
    }
  }

  form {
    .el-form-item {
      margin-bottom: 0px;
      .el-form-item__content {
        line-height: normal;
        .el-input-group__prepend {
          .el-select {
            width: 55px;
            input {
              text-align:center;
            }
            .el-input--suffix {
              .el-input__inner {
                padding-right: 15px;
              }
              .el-input__suffix {
                display: none!important;
              }
            }
          }
        }
      }
      .el-form-item__label {
        padding: 0px!important;
        margin: 0px!important;
        line-height: 24px;
        font-size: 0.8rem;
      }
    }
  }

  .loading {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    .aside {
      position: absolute!important;
    }
    .main {
      position: absolute!important;
    }
  }

  span.divider {
    width: 10px;
  }

  .title-divider {
    margin-top: 25px;
    span {
      font-size: 0.9rem;
      text-transform: uppercase;
      color: #606266cc;
      width: 100%;
      display: flex;
      justify-content: center;
      font-weight: 500;
      padding-bottom: 8px;
    }
    .el-divider {
      margin: 10px 0px;
    }
  }

  .no-data {
    display: flex;
    justify-content: center;
    flex-flow: column;
    align-items: center;
    margin-top: 100px;
    img {
      width: 160px;
      margin-bottom: 20px;
    }
    p {
      margin-top: 0px;
      color: #606266ad;
      margin-bottom: 5px;
      &:last-child {
        margin-top: 5px;
        color: #606266ad;
      }
      &.danger {
        color:#ff5c5c;
      }
    }
  }

  .el-tag {
    word-break: break-all!important;
    height: auto!important;
    white-space: inherit!important;
  }

  // Modal propiedades
  ul.list {
    padding: 0px;
    list-style: none;
    border-radius: 3px;
    margin: 0px 0px 5px 0px;
    li {
      padding: 8px 10px;
      cursor: pointer;
      border: 1px solid #dcdfe6;
      margin-bottom: 5px;
      border-radius: 30px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;

      &:first-child {
        color: #606266cc;
        cursor: inherit;
        padding: 5px 0px;
        border-radius: 3px 3px 0px 0px;
        font-weight: 500;
        font-size: 1rem;
        border: 0px;
        text-align: left;
        text-transform: uppercase;

        &:hover {
          background-color: unset;
        }
      }

      &:hover {
        background-color: #f5f7fa!important;
      }

      i {
        font-size: 0.7rem;
        color: #afb0b1;
      }
    }
  }

  // Modal subir archivos
  .upload-dialog {

    .el-dialog {
      border-radius: 0px;

      .el-dialog__header {
        padding: 15px 20px 15px;
        border-bottom: 1px solid #dcdfe6;

        .upload-title {
          display: flex;
          align-items: center;
          justify-content: space-between;

          > i {
            cursor: pointer;
            font-size: 1.2rem;
          }
        }
      }

      .el-dialog__body {
        height: calc(100% - 55px);
        padding: 0px;

        .upload-content {
          width: 100%;
          height: 100%;
          position: relative;
        }
      }
    }

  }

  // Modal altura completa
  .el-dialog__wrapper.full-height {

    &.dialog-buttons {
      .el-dialog__body {
        background-color: #fafafa;

        ul.list {
          margin-bottom: 20px;
          width: 100%;
          li {
            background-color: white;
            border-radius: 6px;
            padding: 10px 20px;
            font-weight: 400;
            text-transform: uppercase;
            font-size: 0.8rem;

            &:first-child {
              font-size: 0.95rem;
              font-weight: 500;
              padding: 5px 0px;
              background-color: unset;
            }
          }
        }
      }
    }

    > .el-dialog {
      height: 90vh;
      margin-top: 0px!important;
      margin-bottom: 0px;
      top: 5vh;

      .el-dialog__header {
        box-shadow: rgba(0, 0, 0, 0.12) 0px 0px 16px;
        padding: 20px;
        position: absolute;
        background-color: white;
        left: 0;
        right: 0;
        z-index: 9;
        text-transform: uppercase;
      }

      .el-dialog__body {
        overflow: auto;
        height: calc(100% - 124px);
        top: 64px;
        position: relative;
        .el-tree {
          background-color: unset;
        }
      }
    }
  }

  // Capa negra de fondo para cerra menu o detail en responsive
  .back-overlay {
    position: absolute;
    background-color: #000000ab;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    display: none;
  }

  .el-dialog__wrapper {
    &.full-height .el-dialog {
      width: 95%;
    }
  }

  .el-message-box {
    width: 95%;
  }

  .company-user-info{
    display:flex;
    justify-content: space-between;
    .user-logout{
      cursor:  pointer;
      font-size: 1.4em;
    }
  }

  @media (min-width: 768px) {
    .el-dialog__wrapper{
      &.full-height {
        &.dialog-buttons {
          .el-dialog__body {
            ul.list {
              margin-bottom: 20px;
              width: 90%;
            }
          }
        }
        .el-dialog {
          width: 80%!important;
        }
      }
    }
    .el-message-box {
      width: 420px;
    }
  }

  @media (min-width: 1120px) {
    .back-overlay {
      display: none!important;
    }
  }

}
</style>
